<template>
  <div>
    <p>{{ t('convertNPKtoPPMDesc') }}</p>
    <EquationBlock
      :equations="equations"
    />
    <hr />
    <div class="row">
      <div class="col-sm">
          <!-- Inputs -->
          <FixedUnitInput
              :input-label="t('fertilizerN')"
              v-model.number="n"
              :unit="t('unitEmpty')"
          />
          <FixedUnitInput
              :input-label="t('fertilizerP')"
              v-model.number="p"
              :unit="t('unitEmpty')"
          />
          <FixedUnitInput
              :input-label="t('fertilizerK')"
              v-model.number="k"
              :unit="t('unitEmpty')"
          />
          <!-- ... additional inputs ... -->
          <FixedUnitInput
              :input-label="t('addedAmount')"
              v-model.number="mlPerL"
              :unit="t('mlPerLiter')"
          />
          <FixedUnitInput
              :input-label="t('sgOverride')"
              v-model.number="sg"
              :unit="t('unitEmpty')"
          />
          <i>{{ t('sgOverrideNote') }}</i>
          <!-- ... additional inputs ... -->
          <p>{{ t('npkMassPercentageNote') }}</p>
          <FixedUnitInput
              :input-label="t('nMassFraction')"
              v-model.number="nMP"
          />
          <FixedUnitInput
              :input-label="t('pMassFraction')"
              v-model.number="pMP"
          />
          <FixedUnitInput
              :input-label="t('kMassFraction')"
              v-model.number="kMP"
          />
      </div>
      <div class="col-sm">
        <!-- Outputs -->
        <FixedUnitOutput
          :output-label="t('dilutedN')"
          :number="dilutedN"
          :unit="t('ppmTDS')"
        />
        <FixedUnitOutput
          :output-label="t('dilutedP')"
          :number="dilutedP"
          :unit="t('ppmTDS')"
        />
        <FixedUnitOutput
          :output-label="t('dilutedK')"
          :number="dilutedK"
          :unit="t('ppmTDS')"
        />
        <FixedUnitOutput
          :output-label="t('totalDiluted')"
          :number="totalDiluted"
          :unit="t('ppmTDS')"
        />
      </div>
    </div>
  </div>
</template>

  
  <script>
  import { ref, computed, reactive } from 'vue';
  import FixedUnitInput from '../inputs/FixedUnitInput.vue';
  import FixedUnitOutput from '../inputs/FixedUnitOutput.vue';
  import EquationBlock from '../inputs/EquationBlock.vue';
  import { defaultRound } from '../../utils/math';
  import { useI18n } from 'vue-i18n';
  
  export default {
    components: {
      FixedUnitInput,
      FixedUnitOutput,
      EquationBlock,
    },
    setup() {
        // Reactive states for all input fields
        const n = ref(25);
        const p = ref(4);
        const k = ref(2);
        // ... other states like nMP, pMP, kMP ...
        const nMP = ref(1);
        const pMP = ref(0.43641);
        const kMP = ref(0.83014);
        const mlPerL = ref(1);
        const sg = ref(1.0);

        const { t, tm } = useI18n();

        // Create a reactive object with a function
        const translations = reactive({
          t: (key) => t(key)
        })

        const equations = computed(() => {
            return tm('NpkToTdsEquations');
        });
    
        // Computed properties for diluted N, P, K, and total values
        const dilutedN = computed(() => defaultRound(getDilutedValue(n, nMP)));
        const dilutedP = computed(() => defaultRound(getDilutedValue(p, pMP)));
        const dilutedK = computed(() => defaultRound(getDilutedValue(k, kMP)));
        const totalDiluted = computed(() => dilutedN.value + dilutedP.value + dilutedK.value);
    
        const getDilutedValue = (element, elementMP) => {
            const percentMixture = mlPerL.value / 1000;
            const finalPercent = percentMixture * element.value;
            const finalPPM = finalPercent * 10000;
            return finalPPM * elementMP.value * sg.value;
        };
    
        return {
            n, p, k, // ... other states ...
            mlPerL, sg,
            dilutedN, dilutedP, dilutedK, totalDiluted,
            equations,
            nMP, pMP, kMP,
            t: translations.t
        };
    },
  };
  </script>
  